<div *ngIf="this.taskId && assessCase" class="fixed w-full h-full inset-0 flex items-center justify-center bg-main-background bg-opacity-75 z-30 gap-4">
    <div class="w-full h-[90%] max-w-screen-lg flex flex-row gap-1 justify-center overflow-y-auto">
        <div class="w-full h-full flex min-w-full bg-white p-5 rounded-md text-center shadow-lg">
            <div class="w-full h-full flex flex-col items-center justify-start gap-4">
                <div class="w-full flex flex-col items-center justify-center p-4 rounded-lg bg-green-50">
                    <div class="w-full flex gap-2 items-center justify-between">                        
                        
                    <h2 class="pb-4 w-full oswald-font text-2xl font-medium text-start text-green-600">
                        Review
                    </h2>
                        <button
                            class="p-1 rounded-full hover:bg-gray-100"
                            (click)="$event.preventDefault(); handleCloseReviewModal();"
                        >
                            <lucide-icon [name]="icons.X" [size]="20" class="text-nside-gray-200"></lucide-icon>
                        </button>
                    </div>
                    <div class="flex items-center w-full space-x-2 text-center oswald-font text-md">
                        <ng-container *ngFor="let form of formsList; let i = index;" class="w-full">
                            <button 
                                *ngIf="assessCase[form.name] === statusEnum.ReviewPending"
                                class="flex items-center justify-between gap-3 text-start"
                                [ngClass]="{
                                    'text-green-600': currentForm === form,
                                    'text-nside-gray-100': currentForm !== form
                                }"
                                (click)="$event.preventDefault(); this.currentForm = form;"
                            >
                                <span 
                                    class="flex items-center justify-center w-8 h-8 me-2 rounded-full shrink-0"
                                    [ngClass]="{
                                        'text-white bg-green-600': currentForm === form,
                                        'text-nside-gray-300 bg-gray-300': currentForm !== form
                                    }"
                                >                                
                                    {{ i + 1 }}
                                </span>
                                    {{ form.title }}
                                <svg class="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 12 10">
                                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m7 9 4-4-4-4M1 9l4-4-4-4"/>
                                </svg>
                            </button>
                        </ng-container>
                    </div>
                </div>

                <review-full-team-assessment 
                    *ngIf="currentForm.name === 'full_team_threat_assessment'" 
                    class="h-full w-full overflow-y-auto" 
                    [caseId]="this.taskId"
                ></review-full-team-assessment>
                
                <review-teacher-staff-interview
                    *ngIf="currentForm.name === 'teacher_staff_interview'" 
                    class="h-full w-full overflow-y-auto" 
                    [caseId]="this.taskId"
                ></review-teacher-staff-interview>

                <review-witness-interview
                    *ngIf="currentForm.name === 'witness_interview'" 
                    class="h-full w-full overflow-y-auto" 
                    [caseId]="this.taskId"
                ></review-witness-interview>
                
                <review-student-of-concern-interview
                    *ngIf="currentForm.name === 'student_of_concern_interview'" 
                    class="h-full w-full overflow-y-auto" 
                    [caseId]="this.taskId"
                ></review-student-of-concern-interview>
                
                <review-parent-interview
                    *ngIf="currentForm.name === 'parent_interview'" 
                    class="h-full w-full overflow-y-auto" 
                    [caseId]="this.taskId"
                ></review-parent-interview>

                <div *ngIf="currentForm.name !== ''" class="w-full flex flex-row gap-2 items-center justify-end">
                    <button 
                        class="py-1.5 w-20 rounded-md oswald-font rounded-md bg-white border border-red-700 text-red-700 hover:bg-red-700 hover:text-white"
                        (click)="$event.preventDefault(); this.showRejectionReason = true;"
                    >
                        Reject
                    </button>
                    <button 
                        class="shadow-custom-2 flex items-center justify-center oswald-font text-white h-full w-20 bg-gradient-to-b rounded-md from-green-500 to-green-600 hover:from-green-500 hover:to-green-700"
                        (click)="$event.preventDefault(); approveAssessment(this.yesNo.Yes);"
                    >
                        Approve
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>

<rejection-reason
    *ngIf="showRejectionReason"
    [caseId]="taskId"
    [form_name]="currentForm.title"
    (onClose)="this.showRejectionReason = false;"
    (onSubmit)="handleRejectionSubmit($event)">
</rejection-reason>

<div *ngIf="loading">
    <spinner></spinner>
</div>
